var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"42fafef0c5b45f61cbd1ff81f20693dd8829dfbb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-nextjs@lutech"]={id:"42fafef0c5b45f61cbd1ff81f20693dd8829dfbb"};
      